export const DesignTypes = [
  {
    type: 'Stripe',
    productLimit: 2,
  },
  {
    type: 'Canvas Left Cracked',
    productLimit: 1,
  },
  {
    type: 'Canvas Right Cracked',
    productLimit: 1,
  },

];

export default DesignTypes;
